import {Component, EventEmitter, Output} from '@angular/core';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { CustomDatepickerI18nService, I18n } from 'src/app/services/custom-datepicker-i18n-service.service';

@Component({
  selector: 'ngbd-datepicker-popup',
  templateUrl: './datepicker-popup.component.html',
  providers: [I18n,{provide: NgbDatepickerI18n, useClass: CustomDatepickerI18nService}]
})
export class NgbdDatepickerPopup {
  @Output() messageEvent = new EventEmitter<any>();
  model: NgbDateStruct;
  max_date:any = {};

  constructor() {
    let newDate = new Date();
    //console.log(newDate, 'newDate');
    let new_max_date = new Date(newDate.getFullYear(), newDate.getMonth()+1,0);
    this.max_date = {
      year: new_max_date.getFullYear(),
      month: new_max_date.getMonth()+1,
      day: new_max_date.getDate(),
    };
    //console.log(this.max_date, 'max_date');    
  }
  onDateSelection(event) {
    this.messageEvent.emit(event);
  }
}